import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MENTORSHIP_PAIR } from "@/data/media";
import { Sparkles, TrendingUp } from "lucide-react";

export const HeroVisual = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 90]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.06]);

  return (
  <div ref={ref} className="relative mx-auto w-full max-w-[520px]" data-testid="hero-visual">
    <div className="pointer-events-none absolute -left-6 -top-6 h-32 w-32 rounded-full border border-[#C9A227]/50 di-float" />
    <div className="pointer-events-none absolute -right-8 bottom-16 h-24 w-24 rounded-full bg-[#E0708A]/25 blur-2xl di-blob" />

    <motion.div
      initial={{ opacity: 0, scale: 0.94, y: 24 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      style={{ y, scale }}
      className="relative overflow-hidden rounded-[999px_999px_28px_28px] border border-[#E8E2E4] bg-[#F3DDE3] shadow-[0_28px_80px_rgba(94,42,82,0.22)]"
    >
      <img
        src={MENTORSHIP_PAIR}
        alt="Imprenditrice elegante in tailleur, simbolo della rete DonnaImpresa"
        className="h-[380px] w-full object-cover object-top transition-transform duration-[1200ms] hover:scale-[1.04] sm:h-[480px] lg:h-[600px]"
        loading="eager"
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#5E2A52]/35 via-transparent to-transparent" />
    </motion.div>

    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7, delay: 0.45 }}
      className="absolute -left-3 top-[22%] hidden rounded-2xl border border-[#E8E2E4] bg-white/90 px-5 py-4 shadow-[0_12px_40px_rgba(94,42,82,0.14)] backdrop-blur-xl sm:block"
      data-testid="hero-floating-card-1"
    >
      <p className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-[#6B5E62]">
        <TrendingUp size={13} className="text-[#E0708A]" /> Imprese in rete
      </p>
      <p className="mt-1 font-display text-2xl text-[#5E2A52]">+38%</p>
    </motion.div>

    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7, delay: 0.6 }}
      className="absolute -right-2 bottom-[12%] hidden rounded-2xl border border-[#E8E2E4] bg-white/90 px-5 py-4 shadow-[0_12px_40px_rgba(94,42,82,0.14)] backdrop-blur-xl sm:block"
      data-testid="hero-floating-card-2"
    >
      <p className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-[#6B5E62]">
        <Sparkles size={13} className="text-[#C9A227]" /> Storie pubblicate
      </p>
      <p className="mt-1 font-display text-2xl text-[#5E2A52]">ogni mese</p>
    </motion.div>
  </div>
  );
};
